import { IDigestApiClient } from "../../../../../Common/CandyApiClient/DigestApiClient/IDigestApiClient";
import { DigestQueryFilter } from "../../../../../Common/CandyApiClient/DigestApiClient/Types/DigestQueryFilter";

import { emptyPicklistQueryResponse, PicklistQueryResponse } from "./PicklistTypes";
import { IPicklist } from "./IPicklist";
import { buildDigestResponse } from "./PicklistQueryResponseBuilder";

export class DigestApiPicklist implements IPicklist {
    private readonly digestApiClient: IDigestApiClient;
    private readonly gId: string;

    public constructor(digestApiClient: IDigestApiClient, gId: string) {
        this.digestApiClient = digestApiClient;
        this.gId = gId;
    }

    public async query(filter?: DigestQueryFilter): Promise<PicklistQueryResponse> {
        const response = await this.digestApiClient.getDigest({ gId: this.gId, filter: filter });
        if (response?.meta == undefined || response?.data == undefined) {
            return emptyPicklistQueryResponse();
        }
        return buildDigestResponse(response);
    }
}
